import React from "react";
import Loader from "../pages/Loader";

/**
 * Renders a centered loader, an error message, or children when data is ready.
 */
export default function DataFetchStatus({
  loading,
  error,
  children,
  minHeight = "180px",
  loaderClassName = "py-5 d-flex justify-content-center align-items-center",
}) {
  if (loading) {
    return (
      <div className={loaderClassName} style={{ minHeight }}>
        <Loader />
      </div>
    );
  }
  if (error) {
    return (
      <p className="text-danger text-center py-4 mb-0 px-3" role="alert">
        {error}
      </p>
    );
  }
  return children ?? null;
}
